import { Icon } from '@fm-nx/svg';
import { useCurrentRefinements } from 'react-instantsearch';

/* eslint-disable-next-line */
export interface SearchCurrentRefinementsProps {}

export function SearchCurrentRefinements(props: SearchCurrentRefinementsProps) {
    const { items, refine } = useCurrentRefinements();

    if (!items) return null;

    const flatItems = items.map((item) => item.refinements).flat();

    return (
        <div className="mx-6 md:grid md:mx-0 md:grid-cols-14">
            <div className="md:col-span-12 md:col-start-2">
                <ul className="flex space-x-3">
                    {flatItems.map((item) => {
                        return (
                            <li key={item.label} className="px-4 py-2 text-sm bg-ivory-100">
                                <button
                                    onClick={() => refine(item)}
                                    className="flex items-center font-medium tracking-wider uppercase font-headline"
                                >
                                    <Icon name="close-circle" size="sm" /> <span className="ml-2">{item.label}</span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}

export default SearchCurrentRefinements;
